import { Component, Inject, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatSnackBar,
} from "@angular/material";
import { FormBuilder, FormGroup } from "@angular/forms";

import { ApirequestService } from "../../../../shared/services/apirequest.service";
import { AlertService } from "../../../../shared/services/alert.service";
import { ShareCollectionComponent } from "./share-collection.component";
import { PromptDialogComponent } from "../../../../shared/common/prompt-dialog/prompt-dialog.component";
import { CustomSnackBarComponent } from "../../../../shared/common/custom-snack-bar/custom-snack-bar.component";
import { MyCollectionDialogComponent } from "./my-collection-dialog.component";

@Component({
  selector: "app-revised-dashboard-my-collection",
  templateUrl: "./my-collection.component.html",
  styleUrls: ["./my-collection.component.scss"],
})
export class RevisedDashboardMyCollectionComponent implements OnInit {
  collectionFolders;
  repository_id: string;
  returnUrl: string;
  toOpen = false;
  isInstructionCollapse: boolean;
  foldersList: any[];
  tooltip: string;

  constructor(
    private apirequestService: ApirequestService,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public alertService: AlertService
  ) {}

  ngOnInit() {
    this.tooltip = "Click to view";
    this.getMyCollectionFolders();
    this.returnUrl = this.route.snapshot.queryParams["returnUrl"];
    this.route.params.subscribe((params) => {
      this.repository_id = params["id"] || "";
      if (this.repository_id != "" && this.repository_id != undefined) {
        this.tooltip = "Click to add measure";
      }
    });
  }

  openMyCollectionDialogue(folder, action) {
    const dialogRef = this.dialog.open(MyCollectionDialogComponent, {
      data: {
        collectionFolder: folder,
        action: action,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getMyCollectionFolders();
    });
  }

  viewMeasures(collectionFolder) {
    if (this.repository_id != "") {
      const dialogRef = this.dialog.open(PromptDialogComponent, {
        panelClass: "customPanelClass",
        data: {
          title: "",
          body: "Do you want to add repository to folder?",
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          console.log("START HERE")
          this.addRepositoryToFolder(collectionFolder);
          this.router.navigate(["/dashboard/my-collection/"]);
        }
      });
    } else {
      // if (collectionFolder.measure_count > 0) {
      this.router.navigate([
        "/dashboard/mycollection/" + collectionFolder.name,
        collectionFolder.id,
      ]);
      // }
    }
  }

  shareFolder(collectionFolder) {
    // pop up to add users
    const dialogRef = this.dialog.open(ShareCollectionComponent, {
      panelClass: "customPanelClass",
      data: {
        collectionFolder: collectionFolder,
        type: "folder",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getMyCollectionFolders();
    });
  }

  shareMeasure(measure) {
    // pop up to add users
    const dialogRef = this.dialog.open(ShareCollectionComponent, {
      panelClass: "customPanelClass",
      data: {
        measure: measure,
        type: "measure",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getMyCollectionFolders();
    });
  }

  addRepositoryToFolder(collectionFolder) {
    let url = "my_collection/add_to_folder/";
    let payload: {
      folder_id: any;
      measure_id?: string;
      intervention_id?: string;
      behaviour_id?: string;
    } = {
      folder_id: collectionFolder.id,
      measure_id: this.repository_id,
    };
    if (this.returnUrl && this.returnUrl.includes("interventiondetails")) {
      console.log("GETTING THIS")
      url = "my_collection/add_to_intervention_folder/";
      payload = {
        folder_id: collectionFolder.id,
        intervention_id: this.repository_id,
      };
    }
    if (this.returnUrl && this.returnUrl.includes("behaviordetails")) {
      console.log("GETTING THIS")
      url = "my_collection/add_to_behaviour_folder/";
      payload = {
        folder_id: collectionFolder.id,
        behaviour_id: this.repository_id,
      };
    }

    this.apirequestService.post(url, payload).subscribe(
      (res) => {
        this.getMyCollectionFolders();
        this.alertService.success(res.message);
        this.snackBar.openFromComponent(CustomSnackBarComponent, {
          data: {
            message: res.message,
            action: "Success",
          },
          duration: 3 * 1000,
          panelClass: ["transparent-snack-bar"],
        });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  private getMyCollectionFolders() {
    const url = "my_collection/dashboard/";
    // Get all folders
    this.apirequestService.get(url).subscribe(
      (res) => {
        this.collectionFolders = res;
        this.foldersList = [
          ...this.collectionFolders.my_folders,
          ...this.collectionFolders.folders_shared_with_me,
        ];
      },
      (error) => {
        console.log(error);
      }
    );
  }

  transform(value: string): string {
    const maxLength = 15;
    if (value.length <= maxLength) {
      return value;
    } else {
      return value.substring(0, maxLength) + "...";
    }
  }
}
